export const GET_ALL_LANGUAGE = 'GET_ALL_LANGUAGE'
export const GET_ALL_PHRASE = 'GET_ALL_PHRASE'
export const ADD_LANGUAGE_GROUP = 'ADD_LANGUAGE_GROUP'
export const ALL_LANGUAGE_GROUP = 'ALL_LANGUAGE_GROUP'
export const ADD_PHRASE = 'ADD_PHRASE'
export const PHRASE_SEARCH = 'PHRASE_SEARCH'
export const PHRASE_SEARCH_BY_LANGUAGE = 'PHRASE_SEARCH_BY_LANGUAGE'
export const LANGUAGE_MANAGER_RESPONSE = 'LANGUAGE_MANAGER_RESPONSE'
export const CLEAR_RESPONSE = 'CLEAR_RESPONSE'
